import { jsx } from '@emotion/react/jsx-runtime';
import { compound, createComponentWithRef, useSlot, SlotProvider } from '@nettbureau/core';
import { TextInput } from '@nettbureau/input';
import { useControlledState } from '@react-stately/utils';
import { BaseField } from './base-field.js';
import { ClearButton } from './clear-button.js';

/**
 * Text fields let users enter and edit text.
 */ const TextField = compound('TextField', createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('TextField', props, ref);
    const { autoFocus, children, css, defaultValue = '', disabled, inputRef, layout, onChange, size, value: controlledValue, variant, ...textInputProps } = mergedProps;
    const [value, setValue] = useControlledState(controlledValue, defaultValue, onChange);
    const overrides = {
        ClearButton: {
            onPress: ()=>setValue('')
        },
        TextInput: {
            ...textInputProps,
            ref: inputRef,
            autoFocus,
            disabled,
            onChange: setValue,
            value
        }
    };
    return /*#__PURE__*/ jsx(BaseField, {
        ref: mergedRef,
        autoFocus: autoFocus,
        css: css,
        disabled: disabled,
        layout: layout,
        size: size,
        variant: variant,
        children: /*#__PURE__*/ jsx(SlotProvider, {
            value: overrides,
            children: children ?? /*#__PURE__*/ jsx(TextInput, {})
        })
    });
}), {
    ClearButton,
    Input: TextInput
});

export { TextField };
//# sourceMappingURL=text-field.js.map
